// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "MenuButton-module--arrow-up-and-down--61e58";
export var headerWithOpaqueBackground = "MenuButton-module--headerWithOpaqueBackground--b823c";
export var icon = "MenuButton-module--icon--23432";
export var line = "MenuButton-module--line--ea3d8";
export var menuOpen = "MenuButton-module--menuOpen--c98e3";
export var menuWrap = "MenuButton-module--menuWrap--8c9b1";
export var visuallyHidden = "MenuButton-module--visuallyHidden--23dea";